import { Box, Grid2, Stack, Typography } from '@mui/material';

import {
  howItWorksGridSx,
  howItWorksStepBadgeSx,
  howItWorksStepCardSx,
  howItWorksStepDescriptionSx,
  howItWorksStepTitleSx,
  howItWorksTitleSx,
} from './HowItWorks.styles';

interface Step {
  title: string;
  description: string;
}

// Rendered in order; the step number is derived from the array index.
const STEPS: readonly Step[] = [
  { title: 'Choose', description: 'Select your preferred spread type.' },
  { title: 'Shuffle', description: 'Click to shuffle the 78-card deck.' },
  { title: 'Select', description: 'Choose cards that resonate with you.' },
  { title: 'Reflect', description: 'Read the meanings and interpret the message.' },
];

function HowItWorks() {
  return (
    <Stack spacing={2}>
      <Typography variant="h5" component="h2" color="primary" sx={howItWorksTitleSx}>
        How It Works
      </Typography>
      <Grid2 container spacing={2} sx={howItWorksGridSx}>
        {STEPS.map((step, index) => (
          <Grid2 key={step.title} size={{ xs: 12, sm: 6 }}>
            <Stack direction="row" spacing={2} sx={howItWorksStepCardSx}>
              <Box sx={howItWorksStepBadgeSx}>{index + 1}</Box>
              <Stack spacing={0.5}>
                <Typography variant="subtitle2" sx={howItWorksStepTitleSx}>
                  {step.title}
                </Typography>
                <Typography variant="caption" sx={howItWorksStepDescriptionSx}>
                  {step.description}
                </Typography>
              </Stack>
            </Stack>
          </Grid2>
        ))}
      </Grid2>
    </Stack>
  );
}

export default HowItWorks;
